<template>
    <div v-if="variant.badge" class="absolute inset-x-0 top-0 translate-y-px transform z-10">
        <div class="flex -translate-y-1/2 transform justify-center">
            <cUtilsEdit @edit="goToVariantField(variant.id, 'variantBadge')">
                <span
                    :style="{
                        'background-color': variant.highlight
                            ? pricing.highlightColor
                            : pricing.backColor,
                        color: variant.highlight ? pricing.backColor : pricing.highlightColor,
                    }"
                    class="inline-flex rounded-full px-4 py-1 text-base font-semibold"
                >
                    {{ variant.badge }}
                </span>
            </cUtilsEdit>
        </div>
    </div>
</template>

<script>
import { usePricingGoTo } from "@/views/tools/pricing/utils/usePricingGoTo";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";

export default {
    name: "LoopBadge",
    props: {
        pricing: Object,
        variant: Object,
    },
    components: {
        cUtilsEdit,
    },
    setup() {
        const { goToVariantField } = usePricingGoTo();
        return {
            goToVariantField,
        };
    },
};
</script>
